import { inject, Injectable, Injector, Type } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RiberaModalContainerUi } from '../ribera-modal-container-ui/ribera-modal-container-ui';
import { ModalRef } from '../utils/modal-ref';
import { RiberaModalRef } from '../utils/ribera-modal-ref';
import { RiberaModalData } from '../models/ribera-modal-data';
import { MODAL_DATA } from '../models/modal-data.token';
import { InjectionToken } from '@angular/core';

export const RIBERA_MODAL_DATA = new InjectionToken<any>('RIBERA_MODAL_DATA');

export interface RiberaModalOptions {
  title?: string;
  buttonText?: string;
  cancelText?: string;
  showCancel?: boolean;
  showActionsButtons?: boolean;
  data?: Record<string, unknown>;
  data2?: unknown;
}

@Injectable({ providedIn: 'root' })
export class RiberaModalContainerService {

  private dialog = inject(DialogService);
  private injector = inject(Injector);
  

  open<TComponent, TResult = unknown>(
    component: Type<TComponent>,
    options: RiberaModalOptions = {}
  ): DynamicDialogRef {

    const modalRef = new RiberaModalRef<TResult>();

    const componentInjector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: ModalRef, useValue: modalRef },
        { provide: MODAL_DATA, useValue: options.data ?? {} },
        { provide: RIBERA_MODAL_DATA, useValue: options.data2 ?? {} }
      ]
    });

    const dialogRef = this.dialog.open(RiberaModalContainerUi, {
      closable: true,
      header: options.title ?? 'Información',
      modal: true,
      styleClass: 'modal-wrapper',
      focusOnShow: false,
      data: {
        title: options.title ?? 'Información',
        component,
        injector: componentInjector,
        buttonText: options.buttonText ?? 'Continuar',
        cancelText: options.cancelText ?? 'Cancelar',
        showCancel: options.showCancel ?? false,
        showActionsButtons: options.showActionsButtons ?? false,
        data: options.data ?? {},
        data2: options.data2 ?? {}
      } satisfies RiberaModalData
    });

    if (!dialogRef) {
      throw new Error('No se pudo abrir el modal');
    }

    modalRef.attach(dialogRef);

    return dialogRef;
  }
}


